import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";

export function TerminosCondicionesPage() {
    return (
        <div className='min-h-screen bg-[#f6f8fb] text-slate-800 flex flex-col'>
            <NavBar isLogged={false} />

            <header className='bg-linear-to-r from-primary to-primary-hover text-white'>
                <div className='mx-auto max-w-5xl px-6 py-10'>
                    <p className='text-xs uppercase tracking-[0.12em] text-white/80'>
                        Legal
                    </p>
                    <h1 className='text-3xl font-bold'>Términos de Servicio</h1>
                    <p className='mt-2 text-sm md:text-base text-white/90'>
                        Última actualización: 23 de abril de 2026
                    </p>
                </div>
            </header>

            <main className='flex-1'>
                <section className='mx-auto max-w-5xl px-6 py-12'>
                    <div className='bg-white rounded-lg shadow-sm border border-slate-200 p-8 space-y-8'>
                        
                        <div>
                            <h2 className='text-lg font-bold mb-3 text-primary'>1. Aceptación</h2>
                            <p className='text-sm leading-6 text-slate-700'>
                                Al acceder a la aplicación móvil o al sitio web https://servix.com.ve/, usted acepta quedar vinculado por estos Términos de Servicio. Si no está de acuerdo, debe abstenerse de utilizar la plataforma.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-lg font-bold mb-3 text-primary'>2. Descripción del Servicio</h2>
                            <p className='text-sm leading-6 text-slate-700'>
                                Servix es una plataforma operada por NUOVOCELL que conecta clientes con proveedores de lubricación y mantenimiento vehicular a domicilio. Actuamos únicamente como intermediario tecnológico y no prestamos directamente los servicios de mantenimiento.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-lg font-bold mb-3 text-primary'>3. Registro y Cuentas</h2>
                            <ul className='list-disc pl-5 text-sm leading-6 text-slate-700 space-y-2'>
                                <li>Debe ser mayor de 18 años para registrarse.</li>
                                <li>Es responsable de la confidencialidad de sus credenciales.</li>
                                <li>Se permite una sola cuenta por persona, la cual es intransferible.</li>
                                <li>Información falsa puede causar la suspensión inmediata de la cuenta.</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className='text-lg font-bold mb-3 text-primary'>4. Pagos y Tarifas</h2>
                            <p className='text-sm leading-6 text-slate-700'>
                                El pago se gestiona directamente entre cliente y proveedor mediante efectivo o transferencia, adjuntando el comprobante a la plataforma. NUOVOCELL no procesa ni retiene fondos. Las tarifas son establecidas por los proveedores y aprobadas por Servix.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-lg font-bold mb-3 text-primary'>5. Limitación de Responsabilidad</h2>
                            <p className='text-sm leading-6 text-slate-700'>
                                NUOVOCELL no se hace responsable por la calidad o seguridad de los servicios prestados, daños al vehículo o propiedad, ni disputas económicas entre las partes. Nuestra responsabilidad total no excederá el valor del servicio en disputa.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-lg font-bold mb-3 text-primary'>6. Propiedad Intelectual y Prohibiciones</h2>
                            <p className='text-sm leading-6 text-slate-700'>
                                Todo el contenido (marca, diseño, código) es propiedad de NUOVOCELL. Está estrictamente prohibido el uso de la app para actividades ilegales, ingeniería inversa o publicación de contenido difamatorio.
                            </p>
                        </div>

                        <div className='bg-blue-50 border-l-4 border-blue-400 p-4'>
                            <p className='text-xs text-blue-800 italic'>
                                <strong>Jurisdicción:</strong> Estos términos se rigen por las leyes de la República Bolivariana de Venezuela. Para dudas o cancelación de cuenta, contacte a <strong>admin@servix.com.ve</strong>.
                            </p>
                        </div>

                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}